import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxBenefitComponent } from './tax-benefit/tax-benefit.component';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [TaxBenefitComponent],
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  exports: [TaxBenefitComponent]
})
export class TaxBenefitModule { }
